import { RateCardRateBase } from '@bringg/types';
import { capitalize } from 'lodash';

const defaultPrecision = 2;

export const getRateBase = (base: RateCardRateBase) => {
	const baseSplit = base.split('_');

	return [capitalize(baseSplit[0]), ...baseSplit.slice(1)].join(' ');
};

export const getOperator = (base: RateCardRateBase) => (base === RateCardRateBase.Flat ? '=' : 'x');

export const getAmountWithPrecision = (value: number): string => {
	const [, decimal] = String(value).split('.');
	return decimal?.length > defaultPrecision ? String(value) : value.toFixed(defaultPrecision);
};
